<template>
  <div>
    <div class="followNews">
      <div class="basic-information-title">跟进信息</div>
      <div>
        <img :src="require('@/assets/img/contact.png')" style="margin-right:  0.2rem;" class="newlyAddImg" alt @click="openUserProfile()" srcset v-if="showCC==true && hasFollowCreated && userExId!=null">

        <img
          :src="require('@/assets/img/newlyAdd.png')"
          style="margin-right:  0.2rem;"
          class="newlyAddImg"
          alt
          @click="redact(1)"
          srcset
          v-if="showCC==true && hasFollowCreated"
        >
      </div>

    </div>

    <div class="product-list"  v-if="list.length>0">
      <div v-for="(item,index) in list" v-bind:key="index">
        <div class="flex product-list-header">
          <div class="flex center">
            <img class="camera"  :src="require('@/assets/img/camera.png')" alt>
            <div class="product-name">门店-{{item.deptName||''}}</div>
          </div>
          <div>
              <div v-if=" item.createdId==salesId && item.followResult==''&&showCC==true"   @click="noSuccess(item.id)"  class="plan-noSuccess" >计划未完成</div>
          </div>
        </div>
        <div class="product-list-content">
          <div class="basic-information-flex"  v-bind:class="item.edit==true?'active':'activeno'" >
            <ul class="basic-information-lists">
                <li>
                <div class="basic-information-lists-item">任务名称</div>
                <div class="basic-information-lists-text">{{item.taskName||''}}</div>
              </li>
                <li>
                <div class="basic-information-lists-item">跟进时间</div>
                <div class="basic-information-lists-text">{{item.followTime||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">跟进方式</div>
                <div class="basic-information-lists-text">{{item.followTypeName||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">跟进结果</div>
                <div class="basic-information-lists-text">{{item.followResultName||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">跟进人</div>
                <div class="basic-information-lists-text">{{item.followUserName||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">所属门店</div>
                <div class="basic-information-lists-text">{{item.deptName||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">跟进备注</div>
                <div class="basic-information-lists-text">{{item.followRemark||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">计划日期</div>
                <div class="basic-information-lists-text">{{item.plannedDate||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">计划备注</div>
                <div class="basic-information-lists-text">{{item.planedRemark||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">计划方式</div>
                <div class="basic-information-lists-text">{{item.plannedWayName||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">提交人</div>
                <div class="basic-information-lists-text">{{item.salesName||''}}</div>
              </li>

            </ul>
          </div>
        </div>

        <!-- 收起 -->
        <div class="flex packUp center" @click="packUp(index)">
          <img
            :src="require('@/assets/img/upArrow1.png')"
            v-if="item.edit==true"
            class="arrow"
            alt
            srcset
          >
          <img
            :src="require('@/assets/img/dowmArrow.png')"
            v-if="item.edit==false"
            class="arrow"
            alt
            srcset
          >
          {{item.edit==true?"收起详情":"展开详情"}}
        </div>
      </div>
    </div>
    <van-actionsheet
      v-model="sheetShow"
      :actions="actions"
      @select="onSelect"
      @cancel="onCancel"
      cancel-text="取消"
    />
            <!-- 弹框 -->
    <div class="product-model">
      <van-popup
      v-model="productShow"
      :overlay="true"
      :close-on-click-overlay="false"
      >
        <div class="model-height">
          <div class="product-title">新增计划及跟进</div>
          <div class="basic-models-list">

            <!-- 跟进信息 -->
            <div class="followNews">
              <div class="basic-information-title">跟进信息</div>
            </div>
            <!-- 任务名称 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title titles">任务名称</div>
              <van-field v-model="pullListB[4]['name']" placeholder="任务名称"/>
            </div>
            <!-- 计划日期 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title titles">跟进时间</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="domnDateTime">
                {{pullListB[0]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
            <!-- 计划日期 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title titles">跟进方式</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(4)">
                {{pullListB[1]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title titles">跟进结果</div>
              <div class="selectUp" @click="downSelections(5)">
                {{pullListB[2]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <!-- 备注 -->
             <div class="remark-title">
                  <div class="remark-titles titles">备注</div>
                  <div class="textareas">
                       <textarea name="" id="" cols="30" rows="10"   v-model="pullListB[3]['name']"    oninput="if(value.length>1024)value=value.slice(0,1024)" ></textarea>
                  </div>
             </div>


            <!-- 计划信息 -->
            <div class="followNews">
              <div class="basic-information-title ">计划信息</div>
            </div>
            <!-- 计划日期 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title titles">计划日期</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="status==false?downSelections(0):''">
                {{pullListA[0]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
            <!-- 计划日期 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title titles">计划</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="status==false?downSelections(1):''">
                {{pullListA[1]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <!-- 备注 -->
             <div class="remark-title">
                  <div class="remark-titles titles">备注</div>
                  <div class="textareas">
                       <textarea name="" id="" cols="30" rows="10"  :disabled="status"  v-model="pullListA[2]['name']"    oninput="if(value.length>1024)value=value.slice(0,1024)"  ></textarea>
                  </div>
             </div>


          </div>

        </div>
                        <!-- 确定取消 -->
            <div class="confirm-cancel">
              <div class="button-flex-color flex-border-button">
                <div class="button-flex-item" @click="cancelFollw">取消</div>
              </div>
              <div class="button-flex-color">
                <div class="button-flex-item button-active" @click="confirmFollw">确定</div>
              </div>
            </div>
      </van-popup>
    </div>
            <!-- 日期筛选 -->
            <van-popup v-model="timeShow" position="bottom" :overlay="true" style="width:100%">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    @confirm="timeConfirm"
                    @cancel="timeCancel"
                    :min-date="minDate"
                    :max-date="maxDate"
                />
            </van-popup>
             <!-- 时间筛选 -->
             <van-popup v-model="datetimeShow" position="bottom" :overlay="true" style="width:100%">
                <van-datetime-picker
                    v-model="currentDateTime"
                    type="datetime"
                    @confirm="dataTimeConfirm"
                    @cancel="datetimeShow=false"
                    :min-date="minDate"
                    :max-date="maxDate"
                />
            </van-popup>
            <!-- 下拉筛选 -->
            <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection"
                    @cancel="onCancelCode"
                    @confirm="onConfirmCode"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>
  </div>
</template>


<script>

import {Dialog} from "vant";

export default {
  name: "",
  data() {
    return {
      list: [],
      salesId:this.$wxuserUtil.getUserId(),
      sheetShow: false,
      productShow:false,
      editSerial:false,
      editTallage:false,
      actions: [
       /* {
          name: "新建计划信息",
          id:1
        },*/
        {
          name: "新建跟进信息",
          id:2
        }
      ],
    // 字典表查询code
      codeList:['Plan','FollowType','FollowResult'],
      pullListA: [
        { name: "", val: "",value:"" }, //计划日期
        { name: "", val: "",value:"" }, //计划
        { name: "", val: "",value:"" }, //备注
      ],
      pullListB: [
        { name: "", val: "",value:"" }, //跟进日期
        { name: "", val: "",value:"" }, //跟进方式
        { name: "", val: "",value:"" }, //跟进结果
        { name: "", val: "",value:"" }, //备注
        { name: "", val: "",value:"" }, //任务名称
      ],
      PlanList:[],                 //计划方式列表
      FollowTypeList:[],           //跟进方式列表
      FollowResultList:[],         //跟进结果
      timeShow:false,              //时间显示
      datetimeShow:false,
      showDownSelection:false,     //下拉菜单展示
      downSelection:[],            //下拉菜单列表
      currentDate:new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate()), // 时间
      minDate:"", // 最小时间
      maxDate:"",
      minDates:"", // 最小时间
      maxDates:"",
      downSelectionVal:0,            // 下拉菜单当前索引
      status:false,                  // false 新增界面  true  修改界面
      custId:"",                     // 客户ID
      userExId:'',                  //外部联系人Id
      typeS:0,                       // 0 新增计划  1  新增跟进信息
      accFollowId:"",
      showCC:true,
      hasFollowCreated : true,//是否有新增跟进计划的权限
      currentDateTime: new Date(), // 时间
    };
  },
  methods: {
   /**
    *
    *  计划未完成进入
    *
    **/
   noSuccess(ID){
     this.status=true;
     this.getCustDetailFollow(ID)
   },
    /**
     *  打开个人信息页接口
     *
     * */
    openUserProfile(){
        wx.invoke('openEnterpriseChat', {
          "externalUserIds": this.userExId,
          "groupName": "",
          "chatId":"",
          fail:function (res) {
            if(res.err_msg != "openUserProfile:ok") {
              //错误处理
              Dialog.alert({
                message: res.err_msg,
              }).then(() => {
                // on close
              });
            }
          }
        })
    },
   /**
    *
    *   时间筛选 确定 取消
    *
    */
    timeConfirm(val){
       if(this.downSelectionVal==0){
          this.pullListA[0]['name']=this.$time(val);
          this.pullListA[0]['value']=this.$time(val);
       }else
       if(this.downSelectionVal==3){
          this.pullListB[0]['name']=this.$time(val);
          this.pullListB[0]['value']=this.$time(val);
       }
         this.timeShow=false;
    },
    timeCancel(){
       this.timeShow=false;
    },
   /**
    *
    *  菜单筛选  确认 取消
    *
    **/
    onConfirmCode(val){
        if(this.downSelectionVal>2){
          this.pullListB[this.downSelectionVal-3]['name']=val.name;
          this.pullListB[this.downSelectionVal-3]['value']=val.value;
        }else{
          this.pullListA[this.downSelectionVal]['name']=val.name;
          this.pullListA[this.downSelectionVal]['value']=val.value;
        }
        this.showDownSelection=false;
    },
    onCancelCode(){
        this.showDownSelection=false;
    },
    /**
     *  底部菜单 回调事件
     */
    onSelect(val) {
      if(val.id==1){
         this.productShow=true;
         this.typeS=0;
      }else
      if(val.id==2){
         this.typeS=1;
         this.productShow=true;
      }
      this.status=false;
      this.sheetShow=false;
      this.accFollowId="";
    },
    redact() {
      this.sheetShow = true;
    },
    onCancel() {
      this.sheetShow = false;
    },
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        this.$api.getQueryByTcode({ tcode: this.codeList[i] })
          .then(Response => {
            switch (this.codeList[i]) {
              case "Plan"                     :  this.PlanList = Response.data;break;
              case "FollowType"               :  this.FollowTypeList = Response.data;break;
              case "FollowResult"             :  this.FollowResultList = Response.data;break;
            }
          });
      }
    },
    /**
     *
     *  跟进信息列表
     *
     */
    getCustListFollow(custId){
      this.custId=custId;
      this.$api.getCustListFollow({
        salesId:this.$wxuserUtil.getUserId(),
        custId:custId||this.$parent.$parent.custId,
        pageNumber:1,
        pageSize:9999,
        }).then(Response=>{
          if(Response.success==true){
            if(Response.data.list.length>0){
               for(let i=0;i<Response.data.list.length;i++){
                Response.data.list[i]['edit']=false;
                Response.data.list[i]['height']='';
               }
               this.list=Response.data.list;
            }
          }
      })
    },

    /**
     *  获取外部联系UserId
     * */
    getExUserId(id){
      this.userExId=id;
    },
    /**
     *
     *  跟进计划详情
     *  @param {String} custId        客户ID
     *  @param {String} salesId       销售用户ID
     *  @param {String} accFollowId   计划主键ID
     *
     */
    getCustDetailFollow(ID){
      this.$api.getCustDetailFollow({
        custId:this.custId||this.$parent.$parent.custId,
        salesId:this.$wxuserUtil.getUserId(),
        accFollowId:ID
      }).then(Response=>{
          if(Response.success){
                  let    $data     =   Response.data;
                  let    $PA       =   [],$PB=[];$PA=this.pullListA;$PB=this.pullListB;
                  $PA[0]['name']=$data['plannedDate'];
                  $PA[0]['value']=$data['plannedDate'];
                  $PA[1]['name']=$data['plannedWayName'];
                  $PA[1]['value']=$data['plannedWay'];
                  $PA[2]['name']=$data['planedRemark'];
                  $PA[2]['value']=$data['planedRemark'];

                  $PB[0]['name']=$data['followTime'];
                  $PB[0]['value']=$data['followTime'];
                  $PB[1]['name']=$data['followTypeName'];
                  $PB[1]['value']=$data['followType'];
                  $PB[2]['name']=$data['followResultName'];
                  $PB[2]['value']=$data['followResult'];
                  $PB[3]['name']=$data['followRemark'];
                  $PB[3]['value']=$data['followRemark'];

                  $PB[4]['name']=$data['taskName'];
                  $PB[4]['value']=$data['taskName'];
                  this.pullListA=$PA;
                  this.pullListB=$PB;
                  this.productShow=true;
                  this.accFollowId=ID;

          }
      })
    },
   /**
     *
     *  收起 打开
     *  @param {Bealoon}  val
     *  @param {Number}   index
     */
    packUp(index) {
      let $list = [];
      $list = this.list;
      if ($list[index]["edit"] == true) {
        $list[index]['edit']=false
        this.list=$list;
      }else
      if ($list[index]["edit"] == false) {
         $list[index]['edit']=true
        this.list=$list;
      }
    },
    /**
     *
     *   点击下拉
     *   @param {Number}  index
     *
     */
    downSelections(index){
         console.log("当前索引",index)
         this.downSelectionVal=index;
         if(index==1||index==4||index==5){
         switch(index){
           case   1         :       this.downSelection=this.PlanList;break;
           case   4         :       this.downSelection=this.FollowTypeList;break;
           case   5         :       this.downSelection=this.FollowResultList;break;
         }
         this.showDownSelection=true;
         }else{
         if(index==0){
           this.minDate=new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
           this.maxDate=new Date(this.$D.getFullYear()+10,this.$D.getMonth(),this.$D.getDate());
         }
         if(index==3){
           this.minDate=new Date(this.$D.getFullYear()-10,this.$D.getMonth(),this.$D.getDate());
           this.maxDate=new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
         }

         this.timeShow=true;
         }
    },
    dataTimeConfirm(val){
        debugger
        this.pullListB[0]['name']=this.$tiemFormat(val,"yyyy-MM-dd hh:mm:ss");
        this.pullListB[0]['value']=this.$tiemFormat(val,"yyyy-MM-dd hh:mm:ss");
        this.datetimeShow=false;
    },
    domnDateTime(){
        this.minDate=new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate());
        this.maxDate=new Date(this.$D.getFullYear()+10,this.$D.getMonth(),this.$D.getDate());
        this.datetimeShow=true;
    },
    cancelFollw(){
         this.productShow=false;
         this.toEmpty();
    },
    // 新增修改跟进记录
    confirmFollw(){
      let data={};
         data['custId']=this.custId||this.$parent.$parent.custId;
         data['salesId']=this.$wxuserUtil.getUserId();
         data['plannedDate']=this.pullListA[0]['name'];
         data['plannedWay']=this.pullListA[1]['value'];
         data['planedRemark']=this.pullListA[2]['name'];
         data['followTime']=this.pullListB[0]['name'];
         data['followType']=this.pullListB[1]['value'];
         data['followResult']=this.pullListB[2]['value'];
         data['remark']=this.pullListB[3]['name'];
         data['accFollowId']=this.accFollowId?this.accFollowId:'';
         data['taskName'] = this.pullListB[4]['name'];
        if(this.typeS==0){
          if(data['plannedDate']==''){
            this.$title('请选择计划日期')
            return;
          }
          if(data['plannedWay']==''){
            this.$title('请选择计划')
            return;
          }
          //删除跟进信息的属性
          if(!this.accFollowId){
            delete data.followTime;
            delete data.followType;
            delete data.followResult;
            delete data.remark;
          }

        }else if(this.typeS==1||this.status==true){
          if(data['followTime']==''){
            this.$title('请选择跟进日期')
            return;
          }
          if(data['followType']==''){
            this.$title('请选择跟进方式')
            return;
          }
          if(data['followResult']==''){
            this.$title('请选择跟进结果')
            return;
          }
          //删除计划信息的属性
          if(!this.accFollowId){
            delete data.plannedDate;
            delete data.plannedWay;
            delete data.planedRemark;
          }
        }else if(this.status==true){

          if(data['followTime']==''){
            this.$title('请选择跟进日期')
            return;
          }
          if(data['followType']==''){
            this.$title('请选择跟进方式')
            return;
          }
          if(data['followResult']==''){
            this.$title('请选择跟进结果')
            return;
          }
        }
       console.log('当前状态',this.status)
       this.$loading();
       this.$api.getCustSaveFollow(data).then(Response=>{
           if(Response.success){
              this.getCustListFollow(this.custId);
              if(this.accFollowId){
              this.$clear("修改成功");
              }else{
              this.$clear("新增成功");
              }
              this.cancelFollw();
              this.productShow=false;
              this.$parent.$parent.getCustDetail(this.custId||this.$parent.$parent.custId)
           }else{
             if(this.type==0){
               this.$title("新增失败");
             }else{
               this.$title(Response.msg || "修改失败");
             }
           }
       })
    },
    //清空全部
  toEmpty(){
    let $B_=[],$A_=[];$A_=this.pullListA;$B_=this.pullListB;
     for(let a=0;a<$A_.length;a++){
        if(a>0){
          $A_[a]['name']="";
          $A_[a]['value']="";
          $A_[a]['val']="";
        }else{
          $A_[a]['name']=this.$time(new Date());
          $A_[a]['value']=this.$time(new Date());
          $A_[a]['val']=this.$time(new Date());
        }
     }
     this.pullListA=$A_;
     for(let i=0;i<$B_.length;i++){
        if(i>0){
          $B_[i]['name']="";
          $B_[i]['value']="";
          $B_[i]['val']="";
        }else{
          $B_[i]['name']=this.$tiemFormat(new Date(),"yyyy-MM-dd hh:mm:ss");
          $B_[i]['value']=this.$tiemFormat(new Date(),"yyyy-MM-dd hh:mm:ss");
          $B_[i]['val']=this.$tiemFormat(new Date(),"yyyy-MM-dd hh:mm:ss");
        }
     }
     this.pullListB=$B_;
  },
   authority(Bl){
   this.showCC=Bl;
   },
  },
  mounted() {
    this.hasFollowCreated = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route,this.$funcKey.FollowCreated);
    this.getQueryByTcode();
    if(status==false){
    this.pullListA[0]['name']=this.$time(new Date());
    this.pullListB[0]['name']=this.$tiemFormat(new Date(),"yyyy-MM-dd hh:mm:ss");
    }
    if(status==true){

    }
  },
  created() {}
};
</script>



<style lang="less" scoped>
.plan-noSuccess{
  font-weight: bold;
  color:red;
 text-decoration: underline;
}
.product-model {
  .titles{
  color:#0d0d0d;
}
  .followNews{
    border:none;
  }
  //  备注
  .remark-title{
    width:100%;
    min-height: 1rem;
    max-height: auto;
    display: flex;
    flex-direction: row;
    margin-left: .5rem;
    margin-top: .3rem;
    margin:  .3rem 0.0rem 0.3rem .5rem;
    .remark-titles{
      width:2.5rem;
    }
    .textareas{
      width:5rem;
      height: 2rem;
      padding: .05rem;
      border:1px solid #E2E2E2;
      textarea{
        width:100%;
        height: 100%;
        border:none;
        outline: none;
        background: #fff;
      }
    }
  }

  .van-popup {
    width: 9rem;
    height: 14.5rem;
    border-radius: 0.3rem;
    .model-height{
      height:13.3rem;
      overflow-y: auto;
    }
    // 确定取消
    .confirm-cancel {
      width: 100%;
      height: 1.4999rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 0.0rem;
      bottom: 0rem;
      .button-flex-color {
        width: 50%;
        height: 1.4999rem;
        text-align: center;
        .button-flex-item {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 1.5rem;
          font-size: 0.4rem;
          background: #222222;
          color: #fff;
        }
        .button-active {
          background: #e51c23;
          color: #fff;
        }
      }
      .flex-border-button {
        // border-right: 1px solid #a4abba;
      }
    }

    .product-title {
      height: 1.5rem;
      line-height: 1.5rem;
      text-align: center;
      font-weight: bold;
      color: #252424;
      font-size:.4rem;
    }
    .basic-models-list {
      height: 11.5rem;
      font-size: 0.35rem;
      overflow-y: auto;
      width: 95%;
      margin: 0 auto;
      overflow: hidden;
      overflow-y: auto;
      .basic-models-list-item,
      .basic-models-list-itemS {
        margin-left: 0.5rem;
        height: 1.2rem;
        -ms-flex-item-align: center;
        align-items: center;
        display: flex;
        flex-direction: row;
        // justify-content: space-between;
        position: relative;
        input{
          border:none;
          outline: none;
          width:100%;
        }
      }
      .selectUp {
        border: 0;
        margin: 0;
        padding: 0;
        width: 100%;
        resize: none;
        display: block;
        color: #323233;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: transparent;
        .uparrow {
          position: absolute;
          right: 0.2rem;
          top: 50%;
          width: 0.3rem;
          height: 0.3rem;
          margin-top: -0.15rem;
        }
        input {
          border: none;
          outline: none;
        }
        textarea {
          border: none;
          outline: none;
          height: 0.8rem;
          width: 4rem;
        }
      }
    }
    .basic-models-list-item:after {
      content: "  ";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #b3b8c3;
      /* 如果不用 background-color, 使用 border-top:1px solid #f00; 效果是一样的*/
      -webkit-transform: scaleY(0.15);
      transform: scaleY(0.15);
    }
    .van-cell {
      padding: 0rem;
    }
    .models-list-item-title {
      width: 5rem;
    }
    .region {
      width: 3rem;
      position: relative;
      height: 1.2rem;
      line-height: 1.2rem;
      -ms-flex-item-align: center;
      align-items: center;
      padding-left: 0.1rem;
      // border-right: 1px  solid  #b3b8c3;
      .uparrow {
        position: absolute;
        right: 0.5rem;
        top: 50%;
        width: 0.3rem;
        height: 0.3rem;
        margin-top: -0.15rem;
      }
    }
  }
}
.newlyAddImg {
  width: 0.5rem;
  height: 0.5rem;
}
.product-list-content{
    .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    }
    .active {
      height: auto!important;

    }
    .activeno {
      height: 3.1rem!important;
    }
    }
.product-list {
  margin: 0.3rem 0.5rem 0.3rem 0.5rem;
  // background: #F2F2F2;
  min-height: 1rem;
  .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    .basic-information-lists {
      li {
        display: flex;
        //    justify-content: space-between;
        -ms-flex-item-align: center;
        align-items: center;
        height: 0.8rem;
        line-height: 0.8rem;
      }
      .basic-information-lists-item {
        width: 2.5rem;
        color: #7e7e7e;
        font-size: 0.35rem;
      }
      .basic-information-lists-text {
        font-size: 0.35rem;
        color: #4d4d4d;
      }
    }
  }
  .product-list-content {
    background: #f2f2f2;
  }
  .packUp {
    padding: 0rem 0.3rem;
    background: #f2f2f2;
    margin-top: 0.05rem;
    margin-bottom: 0.3rem;
    height: 1rem;
    line-height: 1rem;
  }
  .arrow {
    width: 0.4rem;
    height: 0.4rem;
  }
  .product-list-header {
    height: 1rem;
    -ms-flex-item-align: center;
    align-items: center;
    padding: 0rem 0.3rem;
    flex-direction: row;
    justify-content: space-between;
    background: #f2f2f2;
    .product-name {
      color: #2a2a2a;
      font-size: 0.4rem;
      padding-left: 0.3rem;
    }
  }
  .camera,
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
}
.followNews {
  // width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  padding: 0.3rem 0.5rem 0rem 0.5rem;
  border-top: 0.1rem solid rgb(244, 244, 244);
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
  .basic-information-title {
    position: relative;
    color: #2a2a2a;
    font-size: 0.4rem;
    font-weight: 600;
  }
  .basic-information-title::after {
    content: "";
    width: 0.1rem;
    height: 0.35rem;
    position: absolute;
    left: -0.2rem;
    top: 0.12rem;
    background-color: #e10913;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/client/childCompoents/followNews.vue